export default __webpack_public_path__ + "static/media/StrutsAndTiesImg.8a4fc1d9.jpg";